import React from 'react';
import classNames from "classnames";
import { BreadcrumbItem, BreadcrumbProps } from "./PropsType";

export default function Breadcrumb(props: BreadcrumbProps) {
  const {
    className,
    menus,
    prefixCls = "bm-Breadcrumb",
    separator = "/",
  } = props;
  const styleClass = classNames(prefixCls, className);
  return (
    <ol className={styleClass}>
      {(menus as Array<BreadcrumbItem>).map((menu: any, index: number) => {
        return (
          <li key={index}>
            {menu.icon ? menu.icon : null}
            {index === 0 ? null : (
              <span className={`${prefixCls}-separator`}>
                {menu.separator || separator}
              </span>
            )}
            <span className={`${prefixCls}-title`}>{menu.name}</span>
          </li>
        );
      })}
    </ol>
  );
}

